import { useEffect } from 'react';
import { useAccount, useSwitchChain } from 'wagmi';

const AVALANCHE_CHAIN_ID = 43114;

export function useAutoSwitchNetwork() {
  const { isConnected, chainId } = useAccount();
  const { switchChain } = useSwitchChain();

  useEffect(() => {
    // Only switch if connected and not already on Avalanche
    if (isConnected && chainId && chainId !== AVALANCHE_CHAIN_ID) {
      console.log('Auto-switching to Avalanche network...');
      switchChain?.({ chainId: AVALANCHE_CHAIN_ID });
    }
  }, [isConnected, chainId, switchChain]);

  return { targetChainId: AVALANCHE_CHAIN_ID };
}